import { jsxs as o, Fragment as v, jsx as l } from "react/jsx-runtime";
import { forwardRef as y, useState as b, useEffect as p, useCallback as g } from "react";
import s from "./styles.module.less.js";
import k from "./copy-link.svg.js";
import E from "copy-to-clipboard";
import { toast as L } from "react-toastify";
const N = y(
  (e, f) => {
    var m, d;
    const { text: a, tooltip: u, getTranslation: c } = e, [t, h] = b(null);
    p(() => {
      if (typeof a == "string") {
        const i = /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/, n = a.match(i);
        n && h(n[0]);
      }
    }, [a]);
    const r = g((i) => {
      t && (i.preventDefault(), E(t), L.success(c("chat.copied-link")));
    }, [t, c]);
    return p(() => {
      var i;
      return (i = document.getElementById("email-files")) == null || i.addEventListener("click", r), () => {
        var n;
        (n = document.getElementById("email-files")) == null || n.removeEventListener("click", r);
      };
    }, [r, t]), /* @__PURE__ */ o(
      "div",
      {
        ref: f,
        ...e.props,
        className: `${s.inputLabel} ${((m = e.props) == null ? void 0 : m.className) || ""}`,
        style: { ...(d = e.props) == null ? void 0 : d.style, fontWeight: e.bold ? "bold" : "normal", color: e.bold ? "var(--brand-midnight)" : void 0 },
        children: [
          typeof a == "string" && t ? /* @__PURE__ */ o(v, { children: [
            /* @__PURE__ */ l("div", { className: s.mobile, children: /* @__PURE__ */ l("div", { className: s.mobileFileLabel, dangerouslySetInnerHTML: { __html: c("chat.questionnaire-upload-mobile") } }) }),
            /* @__PURE__ */ o("div", { className: s.desktop, children: [
              c("chat.questionnaire-upload-desktop"),
              /* @__PURE__ */ l("div", { style: { display: "inline-block" }, children: /* @__PURE__ */ o("div", { className: s.textWithEmail, onClick: r, children: [
                /* @__PURE__ */ o("div", { children: [
                  /* @__PURE__ */ l("span", { children: t }),
                  "."
                ] }),
                /* @__PURE__ */ l("div", { children: /* @__PURE__ */ l(k, {}) })
              ] }) })
            ] })
          ] }) : a,
          u ?? null
        ]
      }
    );
  }
);
N.displayName = "InputLabel";
export {
  N as InputLabel
};
